import findPosts from "./includes/findPosts";

document.addEventListener('DOMContentLoaded', () => {
	const advancedFilters = [...document.querySelectorAll('.advanced-select__input'), document.querySelector('.header__search-input--new')];
	window.requestTimeout = null;

	if(advancedFilters) {
		advancedFilters.forEach(/** @param {HTMLInputElement} input */ input => {
			input.addEventListener('input', callback);

			input.addEventListener('click', resultsShowCallback);
		});
	}

	document.addEventListener('click', listenerToHideResults);
});

function collectInputValues(inputs) {
	if(!inputs) return;

	const result = {};
	inputs.forEach(input => {
		const check = checkInput(input);

		if(!check) {
			return;
		}

		result[input.name] = input.value
	});

	return result;
}

function getRelatedHiddenInput(input) {
	return input.parentNode.querySelector('input[type=hidden]');
}

/** @param {Event} event */
function callback(event) {
	event.stopPropagation();

	const input = event.target;
	const searchResults = document.querySelector('.search-results');

	clearInputs([...document.querySelectorAll('.advanced-select__input'), document.querySelector('form .header__search-input--new')]);

	if(!input.value || input.value.length <= 3) {
		hideSearchResults(searchResults);
	} else {
		showSearchResults(searchResults);
		const relatedInput = getRelatedHiddenInput(input);

		if(relatedInput) {
			relatedInput.value = getInputValueID(input);
		}
	}

	if(window.requestTimeout) {
		clearTimeout(window.requestTimeout);
	}

	window.requestTimeout = setTimeout(sendAjax.bind(window, this), 250);

}

function clearInputs(inputs) {
	if(!inputs) return;

	inputs.forEach(input => {
		const related = getRelatedHiddenInput(input);

		if(related) {
			if(!checkInput(input)) {
				related.value = '';
				input.value = '';
			}
		}
	});
}

function checkInput(input) {
	if(!(input instanceof HTMLInputElement)) return false;

	return !(!input.value || input.value === 'undefined' || input.value === 'null');
}

function sendAjax() {
	const searchResults = document.querySelector('.search-results');

		const data = collectInputValues([...document.querySelectorAll('input.advanced-select__value, form#searchform input')]);

		data.searchResults = searchResults;

		// findPosts(data);
}

function resultsShowCallback(event) {
	if(!this.value || this.value <= 3) {
		return;
	}

	showSearchResults(document.querySelector('.search-results'));
}

/** @param {HTMLInputElement} input */
function getInputValueID(input) {
	const datalist = input.list;
	if(!datalist) return input.value;

	const options = [...datalist.querySelectorAll('option')];

	if(!options) return input.value;

	for (const optionsKey in options) {
		if(!(options.hasOwnProperty(optionsKey))) break;

		const el = options[optionsKey];
		if(el.value === input.value) return Number(el.dataset.id);
	}
}

function showSearchResults(searchResults) {
	searchResults.classList.add('active');
}

function hideSearchResults(searchResults) {
	searchResults.classList.remove('active');
}

/**
 * @param {Event} event
 */
function listenerToHideResults(event) {
	const searchResults = document.querySelector('.search-results');

	if(!searchResults.classList.contains('active')) {
		return;
	}

	if(event.target.matches(searchResults.classList[0] + ' *' ?? 'search-result *')) {
		return;
	}

	if(event.target.matches('input.advanced-select__input')) {
		return;
	}

	hideSearchResults(searchResults);
}
